<template>
    <div id="rich-client" class="direction-ltr">
        <div class="content-section-b" id="sections-three">
            <div class="container">
                <div class="row justify-content-between">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-5">
                        <div class="straight-it" data-aos="fade-up" data-aos-duration="1200" :class="{'direction-rtl': language === 'he'}">
                            <p class="mb10 subtitle">{{ $t('אצלנו כל מוצר הוא') }}</p>
                            <h2 class="section-heading text-center"><strong>S</strong>ingle <strong>P</strong>age <strong>A</strong>pplication</h2>
                            <p class="lead">{{ $t('SPA זו אפליקציה עצמאית שיכולה לרוץ בתוך הדפדפן ואינה מחייבת טעינת דפים במהלך השימוש.') }}</p>
                            <p class="lead">{{ $t('אתם משתמשים באפליקציות כאלו יום יום. לדוגמה כשאתם גולשים ב Google Maps, Instagram ו WhatsApp web.') }}</p>
                            <p class="lead"><strong>{{ $t('הטכנולוגיה החדשנית ביותר שכל ענקיות הטכנולוגיה בתהליך מעבר אליו, כבר אצלך!') }}</strong></p>
                            <p class="lead">{{ $t('כשמדברים על SPA מדברים קודם כל על חוויית משתמש יוצאת דופן ע"י יצירת סביבת אפליקציה דינמית וטבעית ממש בתוך הדפדפן - ללא טעינת דפים וללא בזבוז זמן.') }}</p>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 straight-it">
                        <img class="img-responsive mx-auto my-auto d-block" src="img/rich-client/rich.png" alt="productive labs about image" data-aos="fade-up" data-aos-duration="1200">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        data (){
            return{
                mobile: window.matchMedia("(max-width:767px)").matches,
            }
        },
        name: 'rich-client',
        computed: {
            ...mapState('layout', {
                language: state => state.language,
            }),
        },
    }
</script>

<style lang="css" scoped>
    #sections-three {
        background: linear-gradient(144deg, #ff512f 10%, #dd2476 65%);
    }
    #sections-three .img-responsive {
        width: 100%;
    }
    .content-section-b {
        padding: 30px 0;
    }
    .section-heading {
        margin-bottom: 30px;
    }
    #sections-three .lead, h2 {
        color: #fff;
    }
    #rich-client h2 {
        font-weight: 400;
        font-size: 30px;
    }
    .lead strong {
        font-weight: bold;
    }
    .mb10 {
        margin-bottom: 10px!important;
        text-transform: uppercase;
        text-align: center;
        color: #fff;
    }
    .straightLeft{
        margin-left: -30px;
        margin-right: 30px;
    }
    .straightLeft-img{
        margin-left: -30px;
        right: 30px;
    }
    .direction-ltr {
        direction: ltr !important;
    }
    .direction-rtl {
        direction: rtl !important;
    }
</style>
